import GoogleMap from "components/GoogleMap/googlemap";
import { MapPinType } from "components/GoogleMap/googleMapPin";
import React from "react";
import { getGoogleUrl } from "utilities/googlemaps";

interface Props {
  airport: server.dto.Airport
}

const AirportGoogleMap = ({ airport }: Props) => {
  const pin: MapPinType = {
    type: "airport",
  };

  return <div className="radius" style={{
    height: 400,
    minHeight: 400,
    overflow: "hidden",
  }}>
    <GoogleMap
      mapId="DEMO_MAP_ID"
      coordinates={[{
        position: { lat: airport.point?.lat, lng: airport.point?.lng },
        pin,
        draggable: false,
        onLoaded: (_, marker) => {
          google.maps.event.addListener(marker, "click", () => {
            const url = getGoogleUrl(null, airport.point);
            if (url) {
              window.open(url);
            }
          });
        }
      }]}
      mapOptions={{
        center: { lat: airport.point?.lat, lng: airport.point?.lng },
        fullscreenControl: true,
        streetViewControl: true,
        mapTypeControl: true,
        zoom: 8,
        scrollwheel: false
      }}
      onLoaded={map => {
        google.maps.event.addListener(map, "mouseover", () => {
          map.setOptions({
            scrollwheel: true
          });
        });

        google.maps.event.addListener(map, "mouseout", () => {
          map.setOptions({
            scrollwheel: false
          });
        });
      }}
    />
  </div>;
};

export default AirportGoogleMap;